import React, { useEffect } from 'react';
import { AlertTitle, Alert } from '@material-ui/lab';

export const ErrorAlert = ({
    errorMessage,
    setErrorMessage
}) => {

    useEffect(() => {
        setTimeout(() => {
            setErrorMessage()
        }, 5000);
    }, [])

    if (errorMessage) {
        return (
            <Alert
                severity="error"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 10000,
                }}
            >
                <AlertTitle>Ошибка!</AlertTitle>
                {errorMessage}
            </Alert>
        )
    } else {
        return (<div />)
    }
}

export const SuccessAlert = ({
  successMessage,
  setSuccessMessage
}) => {

  useEffect(() => {
      setTimeout(() => {
        setSuccessMessage()
      }, 5000);
  }, [])

  if (successMessage) {
      return (
          <Alert
              severity="success"
              color="success"
              style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 10000,
              }}
          >
              <AlertTitle>Отлично!</AlertTitle>
              {successMessage}
          </Alert>
      )
  } else {
      return (<div />)
  }
}
